import styled from 'styled-components';

const LogoArea = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 94px;
  }
`;

export default LogoArea;
